export default {"src":"/_next/static/image/public/images/payment_awaiting_loader.41792cddc53aa63dca0e57bd24d9026f.gif","height":350,"width":350};